/* tslint:disable */
/* eslint-disable */

/**
 * Status of the expense:
 *   - -1 = Rejected
 *   - 0 = Pending
 *   - 2 = Approved
 */
export enum ExpenseStatusEnum {
  Rejected = -1,
  Pending = 0,
  Approved = 2,
  Expired = 3,
  Reversed = 4,
}
